<template>
  <v-card class="xs:wd-px-3">
    <div class="wd-flex wd-px-4 wd-py-0 wd-flex-wrap xs:(wd-flex-nowrap wd-px-0)">
      <div class="wd-flex wd-py-3 xs:py-0">
        <v-skeleton-loader class="wd-mx-4 wd-w-25 wd-h-10" type="ossein" />
        <v-divider vertical />
        <v-skeleton-loader class="wd-mx-4 wd-w-25 wd-h-10" type="ossein" />
        <v-divider vertical class="wd-hidden xs:wd-inline-block" />
      </div>
      <v-divider class="wd-inline-block xs:wd-hidden" />
      <div class="wd-flex wd-py-3 xs:py-0">
        <v-skeleton-loader class="wd-mx-4 wd-w-25 wd-h-10" type="ossein" />
        <v-divider vertical />
        <v-skeleton-loader class="wd-mx-4 wd-w-25 wd-h-10" type="ossein" />
      </div>
      <v-divider class="wd-inline-block xs:wd-hidden" />
      <div class="wd-flex wd-py-3 xs:(py-0 wd-hidden)">
        <v-skeleton-loader class="wd-mx-4 wd-w-25 wd-h-10" type="ossein" />
        <v-divider vertical />
        <v-skeleton-loader class="wd-mx-4 wd-w-25 wd-h-10" type="ossein" />
      </div>
    </div>
    <div class="wd-my-3 wd-mt-0 wd-block md:wd-hidden xs:wd-mt-3">
      <v-skeleton-loader class="wd-mx-4 wd-h-10" type="ossein" />
    </div>
  </v-card>
</template>

<script setup lang="ts"></script>
